import SlimSelect from 'slim-select';

export interface SlimSelectHTMLElement extends HTMLSelectElement {
    slim: SlimSelect,
}

export default function initSlimSelect() {
    const $selects = document.querySelectorAll<HTMLSelectElement>('select.js-slimselect:not(.mounted)');

    $selects.forEach($select => {
        new SlimSelectCustom($select);
    });
}

export class SlimSelectCustom {
    $select: HTMLSelectElement;
    constructor($select: HTMLSelectElement) {
        this.$select = $select;
        this.init();
    }

    /**
     * Init slim select
     */
    init() {
        const select = new SlimSelect({
            select: this.$select,
            showSearch: this.$select.hasAttribute('data-show-search') && this.$select.getAttribute('data-show-search') !== 'false',
            placeholder: (this.$select.getAttribute('data-placeholder') ?? 'Sélectionnez une valeur'),
            searchPlaceholder: 'Rechercher',
            searchText: 'Aucun résultat',
            allowDeselectOption: true,
            showContent: 'down',
            allowDeselect: (document.querySelector('body.post-type-archive-mediatheque') || document.querySelector('.wrapper-tableau-reglementation') ? true : false),
            deselectLabel: (document.querySelector('body.post-type-archive-mediatheque') || document.querySelector('.wrapper-tableau-reglementation') ? '<span></span>' : ''),
            closeOnSelect: this.$select.getAttribute('data-close-on-select') !== 'false',
        });

        if (this.$select.getAttribute('multiple')) {
            this.initMultiple(select);
            select.onChange = () => {
                this.initMultiple(select);
            };
        }

        this.$select.classList.add('mounted');
    }

    /**
     * Init multiple select specification
     * 
     * @param {SlimSelect} select
     * 
     * @return {void}
     */
    initMultiple(select: SlimSelect) : void {
        const ssMultiSelectContainer = select.slim.container.querySelector('.ss-multi-selected');
        const ssValuesContainer = select.slim.container.querySelector('.ss-values');
        const ssPlaceholderContainer = select.slim.container.querySelector('.ss-placeholder');

        if (select.selected().length > 0) {
            if (ssMultiSelectContainer && !ssPlaceholderContainer) {
                // Creation du placeholder avec bouton reset
                // Div placeholber
                const placeholderDiv = document.createElement('div');
                placeholderDiv.classList.add('ss-placeholder');

                // Bouton reset
                const placeholderButtonReset = document.createElement('button');
                placeholderButtonReset.classList.add('ss-placeholder-button-reset');
                placeholderButtonReset.setAttribute('type', 'button');
                placeholderButtonReset.addEventListener('click', (event) => {
                    event.stopPropagation();
                    select.set([]);
                });

                // Nombre d'éléments sélectionnés
                const countSpan = document.createElement('span');
                countSpan.classList.add('ss-placeholder-count');
                countSpan.textContent = `(${select.selected().length})`;

                // Récuperation du label placeholder du SlimSelect
                const placeholderContent = document.createTextNode(select.slim.main.select.element.dataset.label || select.config.placeholderText);

                // Insertion des éléments
                placeholderDiv.appendChild(placeholderContent);
                placeholderDiv.appendChild(countSpan);
                placeholderDiv.appendChild(placeholderButtonReset);
                ssMultiSelectContainer.insertBefore(placeholderDiv, select.slim.container.querySelector('.ss-add'));
            } else if (ssPlaceholderContainer) {
                // Mise à jour du nombre d'éléments sélectionnés
                const countSpan = ssPlaceholderContainer.querySelector('.ss-placeholder-count');
                if (countSpan) {
                    countSpan.textContent = `(${select.selected().length})`;
                }
            }

            ssValuesContainer?.classList.add('hidden');
        } else {
            if (ssMultiSelectContainer && ssPlaceholderContainer) {
                ssMultiSelectContainer.removeChild(ssPlaceholderContainer)
            }

            ssValuesContainer?.classList.remove('hidden');
        }
    }
}
